export class InternalError implements Error {
    constructor(public name: string, public message: string, public innerError: Error | undefined, public stack?: string | undefined) { }
}